module.exports = __webpack_public_path__ + "static/images/dnf-logo.91c1d5b.png";